import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { useAuth } from '@/contexts/AuthContext';
import { hasRole } from '@/lib/utils';
import { trpc } from '@/lib/trpc';
import { haptic } from '@/lib/haptics';

export function Navigation() {
  const { userBusiness } = useAuth();
  const userRole = userBusiness?.role || 'STAFF';
  const utils = trpc.useContext();

  const navItems = [
    { to: '/', label: 'Today', icon: '📋', roles: ['STAFF', 'ADMIN', 'SUPER_ADMIN'] },
    { to: '/inventory', label: 'Inventory', icon: '📦', roles: ['STAFF', 'ADMIN', 'SUPER_ADMIN'] },
    { to: '/reports', label: 'Reports', icon: '📊', roles: ['ADMIN', 'SUPER_ADMIN'] },
    { to: '/settings', label: 'Settings', icon: '⚙️', roles: ['STAFF', 'ADMIN', 'SUPER_ADMIN'] },
  ];

  const visibleItems = navItems.filter((item) =>
    item.roles.some((role) => hasRole(userRole, role))
  );

  // Prefetch route data on hover/touch
  const handlePrefetch = (path: string) => {
    if (['/', '/inventory'].includes(path)) {
      utils.product.list.prefetch();
    }
  };

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-dark/95 backdrop-blur-md border-t border-primary/30 z-40"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="flex justify-around items-center h-[72px] px-1">
        {visibleItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            onMouseEnter={() => handlePrefetch(item.to)}
            onTouchStart={() => handlePrefetch(item.to)}
            onClick={() => haptic.light()}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center justify-center py-2 px-3 rounded-xl transition-all duration-200 min-w-[64px] min-h-[56px] active:scale-[0.92]',
                isActive
                  ? 'bg-primary/10 text-primary'
                  : 'text-gray-500 hover:text-gray-300 hover:bg-white/5'
              )
            }
          >
            {({ isActive }) => (
              <>
                <span className={cn(
                  'transition-all duration-200',
                  isActive ? 'text-[28px] -translate-y-0.5' : 'text-2xl'
                )}>
                  {item.icon}
                </span>
                <span className={cn(
                  'text-[11px] mt-0.5 transition-all',
                  isActive ? 'font-bold text-primary' : 'font-medium'
                )}>
                  {item.label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
